import { createContext, useContext } from "react";

export const FilterStateContext = createContext({
  filterById: "",
  filterByName: "",
  filterByType: "",
  setFilterById: () => {},
  setFilterByName: () => {},
  setFilterByType: () => {},
});
export const useFilterStateContext = () => useContext(FilterStateContext);

export const CreateNewStateContext = createContext({
  setRestaurantEditorData: () => {},
});
export const useCreateNewStateContext = () => useContext(CreateNewStateContext);

export const SortingStateContext = createContext({
  focusSortType: "",
  sortByAZ: "",
  sortByDistance: "",
  sortByPrice: "",
  setFocusSortType: () => {},
  setSortByAZ: () => {},
  setSortByDistance: () => {},
  setSortByPrice: () => {},
});
export const useSortingStateContext = () => useContext(SortingStateContext);

export const AppStateContext = createContext({
  restaurantList: [],
  setRestaurantList: () => {},
  isOpenRestaurantEditor: false,
  setIsOpenRestaurantEditor: () => {},
  handleOpenToast: () => {},
  totalLength: 0,
  setTotalLength: () => {},
  isOpenCommentEditor: false,
  setIsOpenCommentEditor: () => {},
  commentList: [],
  setCommentList: () => {},
});
export const useAppStateContext = () => useContext(AppStateContext);
